import { createStyles, Theme, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        listItemHeading: {
            paddingLeft: theme.spacing(2),
            paddingBottom: 0,
            paddingTop: 0,
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.grey[200],
        },
    })
);
